<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CompanyAPI from "@/services/company/companyAPI";
import hazardIdentificationAPI from "@/services/standards/hazardIdentification/hazardIdentificationAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import Swal from "sweetalert2";
import CheckModal from "@/components/CheckModal"

/**
 * Form elements component
 */
export default {
  page: {
    title: "Metodología para la identificación",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    CheckModal,
    Layout,
    Style,
    PageHeader,
  },
  data() {
    
    return {
      title: "4.1.1 Metodología para la identificación, evaluación y valoración de peligros",
       items: [
       
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Metodología para la identificación , evaluación y valoración de peligros",
          active: true,
        },
      ],
      
    
      
     
    };
  }, 
  methods: {

      /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action 
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {

      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

      // If the user is logged
      if (role) {

        // If the roles array is not empty
        if (roles) {

          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false

        } // Close if the roles arrays is not empty
        
        // If the roles arrays is empty
        else {

          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8

        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions

        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false

      } // Close if the user is logged
      
      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

  
    
   

    async print() {
      try {
        const url = 'https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/standards/MATRIX_RISK.xlsx'
        window.location.href = url
      } catch (error) {
        console.log(error);
      }
    },

   
     
  },

  mounted() {
  
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12  m-0 p-0">
        <div class="card">
          <div class="card-body  ">
             <div class="row">
              <div class="col-md-6 col-sm-12">

<CheckModal>
  <p class="text-justify">
 La metodología utilizada para la identificación de peligros, evaluación y valoración de riesgos, está basada en lo dispuesto en la GTC 45 de 2012.
  </p>
</CheckModal>
</div>
            
              <div class="col-6 text-right m-b-0">
               
                <a href="/forms/peligros"
                  class="btn btn-primary mx-1" id="tooltip">
                <span class="btn-label"> <i class="mdi mdi-arrow-right-bold-outline"></i></span> Procedimiento matriz de identificación peligros
                </a>
                
                <b-tooltip target="tooltip" placement="left">
                  Ir a Procedimiento matriz de identificación peligros del sg-sst
                </b-tooltip>
              </div>
              
             
            </div>
             
             <br/>

            <form class="form-group">

                <div class="table-responsive" v-if="getRole('Consultar')">
                      <table class="
                            pt-2
                            table
                            border-bottom
                            divide-y divide-gray-200
                           table-bordered
                            rounded
                          ">
                        <thead class="bg-primary text-light">
                          <tr>
                            
                            <th class="text-center pt-4 pb-4 align-middle">Clasificación</th>
                            <th class="text-center pt-4 pb-4 align-middle">Biológico</th>
                            <th class="text-center pt-4 pb-4 align-middle">Físico</th>
                            <th class="text-center pt-4 pb-4 align-middle">Químico</th>
                            <th class="text-center pt-4 pb-4 align-middle">Psicosocial</th>
                            <th class="text-center pt-4 pb-4 align-middle">Biomecánico</th>
                            <th class="text-center pt-4 pb-4 align-middle">Condiciones</th>
                            <th class="text-center pt-4 pb-4 align-middle">Fenómenos</th>
                            
                          </tr>
                        </thead>
                        <tbody  class="">
                          <tr>
                            <td class=" bg-primary text-light text-center align-middle">
                             <b>Biológico</b>
                            </td>
                            <td class="text-center align-middle">
                             Virus
                            </td>
                            <td class="text-center align-middle">
                             Ruido (impacto, intermitente y continuo)
                            </td>
                            <td class="text-center align-middle">
                             Polvos orgánicos e inorgánicos
                            </td>
                            <td class="text-center align-middle">
                              Gestión organizacional (estilo de mando,
                              pago, contratación, participación,
                              inducción y capacitación, bienestar
                              social, evaluación del desempeño,
                              manejo de cambios)
                            </td>
                            <td class="text-center align-middle">
                             Postura(prolongada, mantenida, forzada, anti gravitacionales)
                            </td>
                            <td class="text-center align-middle">
                              Mecánico (elementos de máquinas, herramientas, piezas a trabajar, materiales proyectados sólidos o fluidos)
                            </td>
                            <td class="text-center align-middle">
                             Sismo
                            </td>
                            
                            
                          </tr>
                          <tr>
                            <td class="bg-primary text-light text-center align-middle">
                          <b> Físico</b> 
                            </td>
                            <td class="text-center align-middle">
                            Bacterias
                            </td>
                            <td class="text-center align-middle">
                            Iluminación (Luz visible por exceso o deficiencia)
                            </td>
                            <td class="text-center align-middle">
                             Fibras
                            </td>
                            <td class="text-center align-middle">
                             Características de la organización del
                            trabajo (comunicación, tecnología,
                            organización del trabajo, demandas
                            cualitativas y cuantitativas de la labor)
                            </td>
                            <td class="text-center align-middle">
                             Esfuerzo
                            </td>
                            <td class="text-center align-middle">
                             Eléctrico (alta y baja tensión, estática)
                            </td>
                            <td class="text-center align-middle">
                             Terremoto
                            </td>
                            
                            
                          </tr>
                           <tr>
                            <td class="bg-primary text-light text-center align-middle">
                            <b> Químico</b>
                            </td>
                            <td class="text-center align-middle">
                             Hongos
                            </td>
                            <td class="text-center align-middle">
                             Vibración (cuerpo entero, segmentaria)
                            </td>
                            <td class="text-center align-middle">
                             Líquidos (Nieblas y rocíos)
                            </td>
                            <td class="text-center align-middle">
                            Características del grupo social del
                            trabajo (relaciones, cohesión, calidad de
                            interacciones, trabajo en equipo)
                            </td>
                            <td class="text-center align-middle">
                             Movimiento repetitivo
                            </td>
                            <td class="text-center align-middle">
                             Locativo (almacenamiento,
                             superficies de trabajo (irregularidades, deslizantes, con diferencia del nivel) condiciones de orden y aseo, caídas de objeto) 
                            </td>
                            <td class="text-center align-middle">
                             Vendaval
                            </td>
                            
                            
                          </tr>
                           <tr>
                            <td class="bg-primary text-light text-center align-middle">
                            <b>Psicosocial</b> 
                            </td>
                            <td class="text-center align-middle">
                              Rikettsias
                            </td>
                            <td class="text-center align-middle">
                             Temperaturas extremas (calor y frío)
                            </td>
                            <td class="text-center align-middle">
                              Gases y Vapores
                            </td>
                            <td class="text-center align-middle">
                             Condiciones de la tarea (carga mental,
                              contenido de la tarea, demandas
                              emocionales, sistemas de control,
                              definición de roles, monotonía, etc.)
                            </td>
                            <td class="text-center align-middle">
                             Manipulación Manual de cargas 
                            </td>
                            <td class="text-center align-middle">
                             Tecnológico (explosión, fuga,
                             derrame, incendio) 
                            </td>
                            <td class="text-center align-middle">
                             Inundación
                            </td>
                            
                            
                          </tr>
                           <tr>
                            <td class="bg-primary text-light text-center align-middle">
                            <b> Biomecánico</b>
                            </td>
                            <td class="text-center align-middle">
                             Parásitos
                            </td>
                            <td class="text-center align-middle">
                             Presión atmosférica (normal y ajustada)
                            </td>
                            <td class="text-center align-middle">
                             Humos metálicos, no metálicos
                            </td>
                            <td class="text-center align-middle">
                             Interfase persona tarea (conocimientos,
                              habilidades con relación a la demanda
                              de la tarea, iniciativa, autonomía y
                              reconocimiento, identificación de la
                              persona con la tarea y la organización)
                            </td>
                            <td class="text-center align-middle">
                              
                            </td>
                            <td class="text-center align-middle">
                             Accidentes de tránsito 
                            </td>
                            <td class="text-center align-middle">
                            Derrumbe 
                            </td>
                            
                            
                            
                          </tr>
                           <tr>
                            <td class="bg-primary text-light text-center align-middle">
                           <b>  Condiciones de seguridad</b>
                            </td>
                            <td class="text-center align-middle">
                              Picaduras
                            </td>
                            <td class="text-center align-middle">
                             Radiaciones ionizantes (rayos x, beta, gama y alfa)
                            </td>
                            <td class="text-center align-middle">
                             Material particulado
                            </td>
                            <td class="text-center align-middle">
                             Jornada de trabajo (pausas, trabajo
                              nocturno, rotación, horas extras,
                              descansos)
                            </td>
                            <td class="text-center align-middle">
                              </td>
                            <td class="text-center align-middle">
                              Públicos (Robos, atracos, asaltos, atentados, desorden público, etc.)
                            </td>
                            <td class="text-center align-middle">
                              Precipitaciones,
                            (lluvias, granizadas, heladas)
                            </td>
                            
                            
                          </tr>
                         <tr>
                            <td class="bg-primary text-light text-center align-middle">
                             <b> Fenómenos naturales</b>
                            </td>
                            <td class="text-center align-middle">
                              Mordeduras
                            </td>
                            <td class="text-center align-middle">
                              Radiaciones No ionizantes (láser, ultravioleta, infrarroja)
                            </td>
                            <td class="text-center align-middle">
                             
                            </td>
                            <td class="text-center align-middle">
                             
                            </td>
                            <td class="text-center align-middle">
                             
                            </td>
                            <td class="text-center align-middle">
                             Trabajo en Alturas
                            </td>
                            <td class="text-center align-middle">
                             
                            </td>
                            
                            
                          </tr>
                           <tr>
                            <td class="bg-primary text-light text-center align-middle">
                             
                            </td>
                            <td class="text-center align-middle">
                             Fluidos o Excrementos
                            </td>
                            <td class="text-center align-middle">
                             
                            </td>
                            <td class="text-center align-middle">
                             
                            </td>
                            <td class="text-center align-middle">
                             
                            </td>
                            <td class="text-center align-middle">
                             
                            </td>
                            <td class="text-center align-middle">
                             Espacios Confinados
                            </td>
                            <td class="text-center align-middle">
                             
                            </td>
                            
                            
                          </tr>


                       
                        </tbody>
                      </table>
                    </div>
       

    
   
            </form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>